/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DownloadableDataPackage } from './DownloadableDataPackage';
import {
    DownloadableDataPackageFromJSON,
    DownloadableDataPackageFromJSONTyped,
    DownloadableDataPackageToJSON,
    DownloadableDataPackageToJSONTyped,
} from './DownloadableDataPackage';

/**
 * 
 * @export
 * @interface PaginatedDownloadableDataPackageList
 */
export interface PaginatedDownloadableDataPackageList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedDownloadableDataPackageList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedDownloadableDataPackageList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedDownloadableDataPackageList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<DownloadableDataPackage>}
     * @memberof PaginatedDownloadableDataPackageList
     */
    results: Array<DownloadableDataPackage>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedDownloadableDataPackageList
     */
    numPages?: number;
}

/**
 * Check if a given object implements the PaginatedDownloadableDataPackageList interface.
 */
export function instanceOfPaginatedDownloadableDataPackageList(value: object): value is PaginatedDownloadableDataPackageList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedDownloadableDataPackageListFromJSON(json: any): PaginatedDownloadableDataPackageList {
    return PaginatedDownloadableDataPackageListFromJSONTyped(json, false);
}

export function PaginatedDownloadableDataPackageListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedDownloadableDataPackageList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] === undefined ? undefined : json['next'] === null ? null : json['next'],
        'previous': json['previous'] === undefined ? undefined : json['previous'] === null ? null : json['previous'],
        'results': ((json['results'] as Array<any>).map(DownloadableDataPackageFromJSON)),
        'numPages': json['num_pages'] == null ? undefined : json['num_pages'],
    };
}

export function PaginatedDownloadableDataPackageListToJSON(json: any): PaginatedDownloadableDataPackageList {
    return PaginatedDownloadableDataPackageListToJSONTyped(json, false);
}

export function PaginatedDownloadableDataPackageListToJSONTyped(value?: PaginatedDownloadableDataPackageList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(DownloadableDataPackageToJSON)),
        'num_pages': value['numPages'],
    };
}

